export const GUIDED_TOUR = {
  AddParty: {
    title: 'Add Yourself to Your Waitlist',
    text: "It's easy to see how this works, so give it a try after the tour."
  },
  AddEditParty: {
    title: 'Enter Your Name and Phone',
    text: "If we recognize the phone number, we'll automatically add the name."
  },
  Notify: {
    title: 'Click to Text (or Call) Yourself',
    text: `We suggest you page people 5-10 minutes before you're ready for them. Want to change your message? Click "Settings" to update it.
We also recommend including a link to your social media page in your notification, or you can write something like: "Reply 1 to confirm, 9 to cancel."`
  },
  Sort: {
    title: "Sort Your Waitlist by Clicking a Column Header",
    text: "Click twice to sort the opposite way. Change your sort default in Settings. (This won't do anything until you have more than 1 person on your list!)",
  },
  Search: {
    title: "Search Your Waitlist",
    text: "Use this to sort and filter your list to a subset of guests.",
  },
  Actions: {
    title: "Take Action",
    text: "Mark yourself as served with the checkmark button. You can also cancel yourself, edit your info, or open an SMS chat window.",
  },
  Reservations: {
    title: "Keep Track of Reservations or Appointments",
    text: "Add expected customers here. They will display in-line with the wait list, so you will have a full view of what's upcoming."
  },
  Recent: {
    title: "View Recent Customers",
    text: "You can see when you paged people, or move customers back to your waitlist."
  },
  Analytics: {
    title: "Analyze Your Data",
    text: "After a week or two, you should have valuable information you can use to improve your business."
  },
  Settings: {
    title: "Modify Your Settings",
    text: "Customize your experience, like changing the notifications you send your guests, enabling your public waitlist, and much more."
  },
  Final: {
    title: "That's It!",
    text: "We hope you enjoy the TablesReady waitlist management and paging service!"
  },
}
